import { join } from 'path';

import { fetchGet, fetchPost, fetchPut } from '#providers/Fetch';
import makeHandler from '#services/makeHandler';

const URL = {
  fetch : id => join('order', id),
  update: 'order',
  events: 'order/events',
};

const fetch = makeHandler(async (id, { expand, ...query } = {}) => {
  // TODO: Move to fetchGet provider
  const processedExpand = expand ? expand.reduce(
    (acc, field) => (acc
      ? `${acc}&expand=${field}`
      : `?expand=${field}`), ''
  ) : '';
  const url = `${URL.fetch(id)}${processedExpand}`;
  return fetchGet(url, query);
},
{ defaultError: 'Error fetching order' });

const update = makeHandler(async data => fetchPut(URL.update, data), { defaultError: 'Error updating order' });

const events = makeHandler(async data => fetchPost(URL.events, data), { defaultError: 'Error executing event' });

export default {
  fetch,
  update,
  events,
};
